module.exports = __webpack_public_path__ + "img/icon-cancel.75787743.svg";